import styled from "styled-components";
import ArrowForward from "../../../assets/icons/arrow-forward.svg";

export const ForwardArrowGlyph = styled.span`
  display: inline-block;
  width: 1em;
  height: 1em;
  flex: none;
  background-color: currentColor;
  mask: url(${ArrowForward}) center / contain no-repeat;
  -webkit-mask: url(${ArrowForward}) center / contain no-repeat;
`;
